import * as geojson from "geojson";

/** [[west, south], [east, north]] of any GeoJSON geometry, or null. */
export function bboxOfGeometry(g: geojson.Geometry | null | undefined): [[number, number], [number, number]] | null {
  if (!g) return null;
  let w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
  const visit = (c: any) => {
    if (typeof c[0] === "number") {
      w = Math.min(w, c[0]); e = Math.max(e, c[0]); s = Math.min(s, c[1]); n = Math.max(n, c[1]);
    } else c.forEach(visit);
  };
  if (g.type === "GeometryCollection") g.geometries.forEach((x) => visit((x as any).coordinates));
  else visit((g as any).coordinates);
  if (!isFinite(w)) return null;
  return [[w, s], [e, n]];
}
